import { ChangeEventHandler, FC, Fragment, useMemo, useState } from 'react';

import { Coins } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { AdCard } from './adCard/AdCard';
import { AddAdsForm } from './addAdsForm/AddAdsForm';

import css from './AdsSettingsPage.module.css';

import { adsService } from 'v2/api/adsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { SearchTextField } from 'v2/components/searchTextField/SearchTextField';

export const AdsSettingsPage: FC = () => {
  const [search, setSearch] = useState('');

  const { data, isLoading, mutate } = useSWR('getAds', adsService.getAds);

  const searchedAds = useMemo(() => {
    if (isEmpty(search)) return data;

    return data?.filter((ad) => ad.key.includes(search));
  }, [search, data]);

  const handleSearch: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearch(e.target.value);
  };

  return (
    <PageLayout className={css.adsSettingsPage} overflow="hidden">
      <PageTitle>Ads Settings</PageTitle>

      <div className={css.adsSettingsPageContent}>
        <AddAdsForm onSuccess={mutate} />

        <Card className={css.adsListCard}>
          <div className={css.adsListCardHeader}>
            <CardHeader title="All Ads" icon={Coins} />

            <SearchTextField value={search} onChange={handleSearch} label="Ad" />
          </div>

          {isLoading ? (
            <Loader />
          ) : (
            isNonNullish(searchedAds) && (
              <Fragment>
                {isEmpty(searchedAds) ? (
                  <EmptyPlaceholder />
                ) : (
                  <div className={css.adsList}>
                    {searchedAds.map((ad) => (
                      <AdCard key={ad.id} ad={ad} onRevalidate={mutate} />
                    ))}
                  </div>
                )}
              </Fragment>
            )
          )}
        </Card>
      </div>
    </PageLayout>
  );
};
